// src/store/thunks/authThunks.js
import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import authService from "../../services/authService";

export const getMyDetailsThunk = createAsyncThunk(
  "admin/getMyDetails",
  async (_, { rejectWithValue }) => {
    try {
      const response = await authService.getMyDetails();
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

// Thunk Actions
export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async ({ email, password, customerKey }, { rejectWithValue }) => {
    try {
      const response = await authService.login(email, password, customerKey);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

// Setup Thunks
export const completeInitialSetupThunk = createAsyncThunk(
  "admin/completeInitialSetup",
  async (setupData, { rejectWithValue }) => {
    try {
      const response = await authService.completeInitialSetup(setupData);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const getSystemInitStatusThunk = createAsyncThunk(
  "admin/getSystemInitStatus",
  async (_, { rejectWithValue }) => {
    try {
      const response = await authService.getSystemInitStatus();
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const requestPasswordReset = createAsyncThunk(
  "auth/requestPasswordReset",
  async ({ email, customerKey }, { rejectWithValue }) => {
    try {
      const response = await authService.requestPasswordReset(
        email,
        customerKey
      );
      return response;
    } catch (error) {
      const errorMessage =
        error.response?.data?.displayMessage ||
        error.response?.data?.message ||
        error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const logout = createAsyncThunk(
  "auth/logout",
  async (_, { rejectWithValue }) => {
    try {
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      return {}; // Return an empty object to handle the fulfilled case correctly
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const clearAuthError = createAction("auth/clearAuthError");
export const clearPasswordResetMessage = createAction(
  "auth/clearPasswordResetMessage"
);
